export class DragAndDrop {
    public static RemoveDraggedResource: boolean;
}